import yaml from 'js-yaml'
export default yaml.load(`
- name: Saturday School
  role: Designer
  path: "/works/saturday-school/"
  thumb: "/works/inline-at-line-hack/inline-preview.jpg"
  cover: "/works/inline-at-line-hack/inline-preview.jpg"

- name: Get Well Soon
  role: Designer
  path: "/works/saturday-school/"
  thumb: "/works/inline-at-line-hack/inline-preview.jpg"
  cover: "/works/inline-at-line-hack/inline-preview.jpg"

- name: Intania Daisy
  role: Designer
  path: "/works/saturday-school/"
  thumb: "/works/inline-at-line-hack/inline-preview.jpg"
  cover: "/works/inline-at-line-hack/inline-preview.jpg"
`)


/** WEBPACK FOOTER **
 ** ../data/volunteering-works.js
 **/